import { render, staticRenderFns } from "./appText.vue?vue&type=template&id=045ff0f1&scoped=true"
import script from "./appText.vue?vue&type=script&lang=js"
export * from "./appText.vue?vue&type=script&lang=js"
import style0 from "./appText.vue?vue&type=style&index=0&id=045ff0f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ff0f1",
  null
  
)

export default component.exports